(() => {
  const root = document.getElementById('gk-wishlist-root');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';
  const key = 'gyllta-kistan-favorites-v1';
  const dialog = root.querySelector('dialog');
  const list = root.querySelector('[data-gk-list]');
  const status = root.querySelector('[data-gk-status]');
  const labels = root.dataset;
  let favorites = [];
  const valid = item => item && typeof item.handle === 'string' && /^[a-z0-9-]+$/.test(item.handle) && typeof item.title === 'string' && typeof item.url === 'string' && item.url.startsWith('/') && !item.url.startsWith('//');
  const read = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      favorites = Array.isArray(stored) ? stored.filter(valid).slice(0, 200) : [];
    } catch { favorites = []; }
  };
  const announce = text => { status.textContent = text; };
  const selected = handle => favorites.some(item => item.handle === handle);
  const sync = () => {
    document.querySelectorAll('[data-gk-favorite]').forEach(button => {
      const saved = selected(button.dataset.handle);
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', (saved ? labels.remove : labels.add).replace('[product]', button.dataset.title));
      const label = button.querySelector('[data-gk-favorite-label]');
      if (label) label.textContent = saved ? labels.saved : labels.save;
    });
    const counter = root.querySelector('[data-gk-count]');
    if (counter) counter.textContent = String(favorites.length);
  };
  const render = () => {
    list.replaceChildren();
    root.querySelector('[data-gk-legacy-title]').hidden = !favorites.length;
    if (!favorites.length) return;
    favorites.forEach(item => {
      const row = document.createElement('div');
      row.className = 'gk-wishlist-item';
      const link = document.createElement('a');
      link.href = item.url;
      if (typeof item.image === 'string' && item.image) {
        try {
          const imageUrl = new URL(item.image, location.origin);
          if (imageUrl.protocol === 'https:' && (imageUrl.origin === location.origin || imageUrl.hostname === 'cdn.shopify.com')) {
            const img = document.createElement('img');
            img.src = imageUrl.href; img.alt = ''; img.width = 72; img.height = 82; img.loading = 'lazy';
            link.append(img);
          }
        } catch {}
      }
      const title = document.createElement('span');
      title.textContent = item.title;
      link.append(title);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'gk-wishlist-remove'; remove.textContent = '×';
      remove.dataset.gkRemove = item.handle;
      remove.setAttribute('aria-label', labels.remove.replace('[product]', item.title));
      row.append(link, remove); list.append(row);
    });
  };
  const save = next => {
    try { localStorage.setItem(key, JSON.stringify(next)); }
    catch { announce(labels.error); return false; }
    favorites = next; sync(); render(); return true;
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-gk-favorite]');
    if (!button) return;
    event.preventDefault();
    read();
    const item = { handle: button.dataset.handle, title: button.dataset.title, url: button.dataset.url, image: button.dataset.image };
    if (!valid(item)) return;
    const wasSaved = selected(item.handle);
    if (!wasSaved && favorites.length >= 200) { announce(labels.error); return; }
    const next = wasSaved ? favorites.filter(entry => entry.handle !== item.handle) : [...favorites, item];
    if (save(next)) announce((wasSaved ? labels.remove : labels.add).replace('[product]', item.title));
  });
  root.querySelector('.gk-wishlist-open').addEventListener('click', () => {
    read(); sync(); render();
    if (!dialog.open) dialog.showModal();
  });
  root.querySelector('[data-gk-close]').addEventListener('click', () => dialog.close());
  root.querySelector('[data-kistan-open]').addEventListener('click', () => dialog.close());
  root.querySelector('[data-kistan-open]').addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); event.currentTarget.click(); }
  });
  dialog.addEventListener('click', event => {
    if (event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    }
    const remove = event.target.closest('[data-gk-remove]');
    if (!remove) return;
    read();
    const handle = remove.dataset.gkRemove;
    const previous = [...list.querySelectorAll('[data-gk-remove]')].indexOf(remove);
    if (save(favorites.filter(item => item.handle !== handle))) {
      const remaining = [...list.querySelectorAll('[data-gk-remove]')];
      (remaining[Math.min(previous, remaining.length - 1)] || root.querySelector('[data-gk-close]')).focus();
    }
  });
  window.addEventListener('storage', event => { if (event.key === key || event.key === null) { read(); sync(); render(); } });
  document.addEventListener('shopify:section:load', sync);
  const main = document.getElementById('MainContent');
  if (main) {
    let pending = false;
    new MutationObserver(records => {
      if (pending || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-gk-favorite]') || node.querySelector('[data-gk-favorite]'))))) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; sync(); });
    }).observe(main, { childList: true, subtree: true });
  }
  read(); sync();
})();
